import DtvBox from "@directv-digital/dds.ui.dtv-box";
import React, { useState } from "react";
import { TextField as FusionTextField } from "./text-field";
import { fireCustomLinkClickGA } from "@directv-digital/dds.services.analytics-service";
import { mediaModuleStyles } from "../media-module.style";
import DtvButton from "@directv-digital/dds.ui.dtv-button";
import {
  IEmailCaptureFormProps,
  MediaModuleImageVariant
} from "../media-module.types";

const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const EmailCaptureForm = (props: IEmailCaptureFormProps) => {
  const { field, submitCta, variant, id } = props;

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const styles = mediaModuleStyles({});

  const handleEmailCapture = () => {
    function isAbsoluteUrl(url) {
      try {
        new URL(url);
        return true; // If URL constructor works, it's absolute
      } catch (_e) {
        return false; // If it throws, it's relative
      }
    }

    if (EMAIL_PATTERN.test(email)) {
      fireCustomLinkClickGA({
        linkName: "submit",
        linkPosition: `media_module_image_card-${
          variant === MediaModuleImageVariant.ONE_UP ? "1up" : "2up"
        }`,
        linkDestination: isAbsoluteUrl(submitCta?.targeturl) ?
          submitCta?.targeturl :
          `${window.location.origin}${submitCta?.targeturl}`
      });
      sessionStorage.setItem("ffpEmail", email);
      window.location.href = submitCta?.targeturl;
    }
  };

  return (
    <DtvBox sx={styles.emailCaptureContainer}>
      <FusionTextField
        error={emailError}
        helperMessage={!!emailError}
        helperMessageIcon={!!emailError}
        label={field?.label}
        type="email"
        value={email}
        InputLabelProps={{
          sx: {
            ...styles.inputLabelRootStyles,
            ...(field?.size === "medium" && styles.inputLabelRootStylesMedium),
            ...(field?.size === "large" && styles.inputLabelRootStylesLarge)
          }
        }}
        InputProps={{
          sx: {
            ...styles.InputPropsStyles,
            ...(field?.size === "medium" && styles.InputPropsStylesMedium),
            ...(field?.size === "large" && styles.InputPropsStylesLarge)
          }
        }}
        helperMessageText={
          emailError ?
            emailErrorMsg !== "" ?
              emailErrorMsg :
              field?.emailErrorMessage :
            " "
        }
        inputProps={{
          sx: styles.inputPropsStyles
        }}
        onBlur={e => {
          if (!EMAIL_PATTERN.test(e.target.value)) {
            setEmailError(true);
            setEmailErrorMsg("Please enter a valid email");
          }
        }}
        onChange={e => {
          setEmail(e?.target?.value);
          setEmailError(false);
          setEmailErrorMsg("");
        }}
      />
      {submitCta?.label && (
        <DtvButton
          aria-label={submitCta?.label}
          id={`${id}-cta`}
          {...submitCta}
          targeturl="javascript:void(0);"
          sx={{
            ...styles.button,
            ...styles.submitCta(submitCta?.color, submitCta?.backgroundColor),
            ...(submitCta?.size === "medium" && styles.buttonMedium),
            ...(submitCta?.size === "large" && styles.buttonLarge)
          }}
          onClick={handleEmailCapture}
        />
      )}
    </DtvBox>
  );
};
